<template>
  <canvas :height="height || '200px'" :width="width" :id="this.id"></canvas>
</template>

<script>
import Chart from "chart.js";
export default {
  props: ["id", "type", "labels", "dataChart", "height", "description", "subtitlePosition", "dark", "backgroundColor", "width", "maintainAspectRatio", "layoutPadding"],
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    dados() {
      this.montaChart();
    }
  },
  methods: {
    unmountChart() {
      this.chart.destroy();
    },
    montaChart() {
      var tela = document.getElementById(this.id).getContext("2d");
      this.chart = new Chart(tela, {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: [
            {
              label: this.description,
              backgroundColor: this.backgroundColor,
              borderColor: this.dark ? '"#333"' : '#000',
              data: this.dataChart,
            },
          ]
        },
        options: {
          maintainAspectRatio: this.maintainAspectRatio !== false,
          layout: {
            padding: this.layoutPadding || 0
          },
          legend: {
            display: true,
            labels: {
              fontColor: this.dark ? '#fff' : "#333",
            },
            position: this.subtitlePosition || 'right' // Coloque a legenda na parte inferior
          },
          responsive: true,
        },
      });
    }
  },
  mounted() {
    this.montaChart();
  }
};
</script>
